import {
  ErpDataTableV2,
  ErpInputTableV2,
  LoadingOverlayV2,
  BulkDeleteDialog,
  DeleteDialog
} from '@/components/custom/erp';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '@/components/ui/resizable';
import { PhieuThuProvider, usePhieuThuPage } from './context';
import { PhieuThuForm } from './components/PhieuThuForm';
import SearchDialog from './components/SearchForm';
import { TABLE_PAGE_SIZE } from './constants';
import { ActionBar } from './components';

function PhieuThuPageContent() {
  const page = usePhieuThuPage();

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {page.searchDialog.open && (
        <SearchDialog
          onClose={page.searchDialog.onClose}
          open={page.searchDialog.open}
          onSearch={page.searchDialog.onSubmit}
          searchFieldState={page.searchDialog.searchFieldState}
        />
      )}

      {page.multipleFormDialog.open && page.multipleFormDialog.invoiceData.length > 0 && (
        <PhieuThuForm
          formMode={page.multipleFormDialog.formMode}
          initialData={page.multipleFormDialog.initialData}
          onSubmit={page.multipleFormDialog.onSubmit}
          onClose={page.multipleFormDialog.onClose}
          currentIndex={page.multipleFormDialog.currentFormIndex}
          totalCount={page.multipleFormDialog.invoiceData.length}
        />
      )}

      {page.formDialog.open && !page.multipleFormDialog.open && (
        <PhieuThuForm
          formMode={page.formDialog.formMode}
          initialData={
            page.formDialog.formMode === 'add' && !page.formDialog.isCopyMode ? undefined : page.formDialog.detail
          }
          onSubmit={page.formDialog.onSubmit}
          onClose={page.formDialog.onClose}
        />
      )}

      {page.deleteDialog.open && (
        <DeleteDialog
          open={page.deleteDialog.open}
          onClose={page.deleteDialog.onClose}
          selectedObj={page.deleteDialog.selectedObj}
          deleteObj={page.deleteDialog.onDelete}
          clearSelection={page.deleteDialog.clearSelection}
        />
      )}

      {page.bulkDeleteDialog.open && (
        <BulkDeleteDialog
          title='Phiếu thu'
          onClose={page.bulkDeleteDialog.onClose}
          columns={page.table.columns}
          dataRows={page.table.displayData}
          handleDelete={page.bulkDeleteDialog.onDelete}
        />
      )}

      <div className={`flex h-full flex-col ${page.formDialog.open || page.multipleFormDialog.open ? 'hidden' : ''}`}>
        {page.actions.isExporting && <LoadingOverlayV2 />}

        <ActionBar
          onAddClick={page.actions.handleAddClick}
          onEditClick={() => page.selection.selectedObj && page.actions.handleEditClick()}
          onDeleteClick={() => page.selection.selectedObj && page.actions.handleDeleteClick()}
          onCopyClick={() => page.selection.selectedObj && page.actions.handleCopyClick()}
          onSearchClick={page.actions.handleSearch}
          onRefreshClick={page.actions.handleRefresh}
          isEditDisabled={!page.selection.selectedObj}
          isDeleteDisabled={!page.selection.selectedObj}
          isCopyDisabled={!page.selection.selectedObj}
        />

        <ResizablePanelGroup direction='vertical' className='flex-1 overflow-hidden'>
          <ResizablePanel defaultSize={55} minSize={20}>
            <div data-perf-id='pt-master-table' className='h-full w-full overflow-hidden'>
              <ErpDataTableV2
                tables={page.table.tables}
                onRowClick={page.actions.handleRowClick}
                onRowDoubleClick={page.actions.handleViewClick}
                selectedRowId={page.selection.selectedRowIndex || undefined}
                totalItems={page.table.totalItems}
                currentPage={page.table.currentPage}
                onPageChange={page.table.onPageChange}
                onSearchChange={page.table.onSearchChange}
                pageSize={TABLE_PAGE_SIZE}
                loading={page.table.displayIsLoading}
              />
            </div>
          </ResizablePanel>

          <ResizableHandle withHandle className='bg-slate-200/80 hover:bg-slate-300' />

          <ResizablePanel defaultSize={45} minSize={20}>
            <div data-perf-id='pt-bottom-detail-table' className='h-full overflow-hidden'>
              <ErpInputTableV2
                rows={page.detailTable.rows}
                columns={page.detailTable.columns}
                showIndexColumn
                actions={{
                  export: () => console.log('Export clicked'),
                  pin: () => console.log('Pin clicked')
                }}
                actionsDisabled={page.formDialog.formMode === 'view' || !page.selection.selectedObj}
                height='100%'
                loading={page.table.displayIsLoading && !page.selection.selectedObj}
              />
            </div>
          </ResizablePanel>
        </ResizablePanelGroup>
      </div>
    </div>
  );
}

export default function PhieuThuPage() {
  return (
    <PhieuThuProvider>
      <PhieuThuPageContent />
    </PhieuThuProvider>
  );
}
